// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","logoImage":"Navbar_logoImage__-Q3w6","logo":"Navbar_logo__jA5Pb","navLinks":"Navbar_navLinks__UMGgk"};